import {ELicensePeriod} from 'src/containers/Licenses/definitions';

import {ESmsOutMessageCategory, ESmsStatisticsChart, EWAConversation} from '../definitions';

export default {
  period: 'Period',
  downloadReport: 'Download report',
  hint: 'The number of message units for which you will need to pay according to your pricing option',
  more: 'More',
  direction: 'Direction',
  count: 'Count',
  cost: 'Cost, {{currencySymbol}}',
  costPerSegment: 'Cost per segment, {{currencySymbol}}',
  operator: 'Operator',
  type: 'Type',
  outgoing: 'Outgoing',
  incoming: 'Incoming',
  incomingMessages: 'Incoming messages',
  outgoingMessages: 'Outgoing messages',
  messagesCount: 'Total',
  sent: 'Sent',
  delivered: 'Delivered',
  notDelivered: 'Not delivered',
  read: 'Read',
  total: 'Total, {{currencySymbol}}',
  incomingCount: 'Number of incoming messages',
  charged: 'Charged',
  promotional: 'Promotional',
  service: 'Service',
  other: 'Other',
  viberReport: {
    minimumPayment: 'Minimum payment',
    viberMinimumPayment: 'Viber minimum payment, {{currencySymbol}}',
  },
  smsReport: {
    averageCostOld: 'Message cost',
    outgoingHintOld: 'Message cost depends on the number of segments in a message',
    ndsHint: 'All prices include VAT',
    emptyMessages: 'No message data for the selected period',
    subscriptionFee: 'Subscription fee',
    operator: 'Operator',
    priceForMonth: 'Cost per month',
    trafficType: 'Traffic type',
    segmentCount: 'Total segments',
    multinaming: 'Multinaming',
    category: 'Category',
    averageCost: 'Cost per message',
    totalCost: 'Total cost, rub.',
    currency: 'Currency',
    charged: 'Charged',
    billingInfo:
      'The information provided is relevant when executing the final report. Data for current month may change',
    defaultInfo:
      'The information provided is preliminary and relevant when executing the final report. Accurate information will be available at the end of the reporting period',
    outgoingHint: 'Message cost depends on the number of segments in a message (PDU)',
    categories: {
      [ESmsOutMessageCategory.SERVICE]: 'Service',
      [ESmsOutMessageCategory.AUTHORIZATION]: 'Authentication',
      [ESmsOutMessageCategory.AUTH]: 'Authentication',
      [ESmsOutMessageCategory.TEMPLATE_ADV]: 'Advertising template',
      [ESmsOutMessageCategory.ADVERTISEMENT]: 'Advertising',
      [ESmsOutMessageCategory.INFO]: 'Advertising',
      [ESmsOutMessageCategory.MARKETING]: 'Advertising',
      [ESmsOutMessageCategory.ADV]: 'Advertising',
    },
    download: 'Download report',
    averageCostHintOld:
      'If the operator uses stepped billing, the average message cost for the category is shown',
    averageCostHint:
      'One message can be up to 160 characters in Latin or up to 70 characters in Cyrillic. If the text is longer, it is split into several messages (up to 150 Latin / 66 Cyrillic characters) and charged as the corresponding number of SMS.',
    detailReport: 'Message details',
    detailReportButton: 'Generate report.xlsx',
    templates: 'Paid templates',
    templateType: 'Template type',
    templateCount: 'Number of templates',
    templateAverageCost: 'Price per unit, per month',
    templateTotalCost: 'Amount, per month',
    statisticsTotalCost: 'Total spent this month: {{amount}} {{currency}}',
    statisticsChart: {
      [ESmsStatisticsChart.LICENSE]: 'License for all channels: {{amount}} ({{percent}}%)',
      [ESmsStatisticsChart.TEMPLATES]: 'Paid templates: {{amount}} ({{percent}}%)',
      [ESmsStatisticsChart.SUBSCRIPTION_FEE]: 'Subscription fee: {{amount}} ({{percent}}%)',
      [ESmsStatisticsChart.OUT_MESSAGES]: 'Outbound messages: {{amount}} ({{percent}}%)',
    },
  },
  whatsappReport: {
    ndsHint: 'All prices include VAT',
    for: 'for',
    licenseTableTitle: 'License',
    licensePeriodTitle: 'License period',
    licenseDuration: 'License validity period',
    licenseBilled: 'Actual amount credited for the period, {{currencySymbol}}',
    licensePeriod: {
      [ELicensePeriod.MONTH]: 'Monthly',
      [ELicensePeriod.YEAR]: 'Annual',
    },
    mauTableTitle: 'MAU / AMAU',
    mauInPackage: 'MAU in package',
    mauQuantity: 'Current number of MAU',
    remainingMau: 'Remaining MAU',
    amauQuantity: 'Current number of AMAU',
    amauPrice: 'Price per AMAU, {{currencySymbol}}',
    totalForAmau: 'Total for AMAU, {{currencySymbol}}',
    billing: 'Message billing',
    billingHint:
      "Only nonzero values are shown. This section doesn't display messages categories that don't have messages in the selected period.",
    free: 'Free',
    incomingMessages: 'Incoming communications',
    incomingDialogs: 'Incoming conversations',
    freeEntryPoints: 'Free entry points',
    chatMessages: 'Non-template messages',
    hsm: 'Template messages',
    user: 'User-initiated',
    business: 'Business-initiated',
    incomingConversation: {
      [EWAConversation.REFERRAL]: 'Free entry points',
      [EWAConversation.SERVICE]: 'Incoming conversations',
    },
    billedConversation: {
      [EWAConversation.SERVICE]: 'Service (non-template)',
      [EWAConversation.UTILITY]: 'Utility',
      [EWAConversation.AUTHENTICATION]: 'Authentication',
      [EWAConversation.MARKETING]: 'Marketing Cloud API',
      [EWAConversation.MARKETING_LITE]: 'Marketing MM API',
    },
  },
  simpleReport: {
    ndsHint: 'Prices are displayed excluding VAT',
    licenseTableTitle: 'License',
    licensePeriodTitle: 'License period',
    licenseDuration: 'License validity period',
    licenseBilled: 'Actual amount credited for the period, {{currencySymbol}}',
    licensePeriod: 'Monthly',
  },
};
